// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__lOt2r","large":"styles_large__3GL4X"};